import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { compact } from 'lodash';
import { compose, setDisplayName } from 'recompose';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { injectIntl } from 'components';
import { isMobile } from 'helpers/detect-mobile';

const styles = () => ({
  appBar: {
    position: 'fixed',
    width: '100%',
  },
  buttonLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  btn: {
    padding: isMobile ? '8px 10px' : '8px 16px',
  },
  toolBar: {
    minHeight: 64,
    paddingRight: isMobile ? 0 : 140,
  },
  loginButton: isMobile ? { display: 'none' } : { display: 'block' },
  brand: isMobile ? { marginRight: 15 } : { marginRight: 0 },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
});

const BasicHeader = ({ classes, formatMessage }) => (
  <AppBar position="static" color="default" className={classes.appBar}>
    <Toolbar className={classes.toolBar}>
      <Typography variant="h6" color="inherit" noWrap className={classes.toolbarTitle}>
        <Link to="/" className={compact([classes.buttonLink, classes.brand]).join(' ')}>
          {formatMessage('FRESHr Sign up')}
        </Link>
      </Typography>
      <Link to="/features" className={classes.buttonLink}>
        <Button className={classes.btn}>{formatMessage('Features')}</Button>
      </Link>
      <Link to="/pricing" className={classes.buttonLink}>
        <Button className={classes.btn}>{formatMessage('Prices')}</Button>
      </Link>
    </Toolbar>
  </AppBar>
);

BasicHeader.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  formatMessage: PropTypes.func.isRequired,
};

export default compose(
  setDisplayName('BasicHeader'),
  injectIntl,
  withStyles(styles),
)(BasicHeader);
